import { Region } from './Region'

export function Regions({ regions }) {
    
    return(
        regions.map((region, index) => (
           <Region 
                key={index}
                region={region}
           />
        ))
        
    )
}
